module.exports = __webpack_public_path__ + "img/mab.539b9107.png";